import { CaseStudyDetailTemplate } from '@templates'
import { ISSRPageData } from '@interfaces'
import { ResearchAreaService } from '@services'

const CaseStudyDetailTR = ({ pageData, global }: ISSRPageData) => {
  return <CaseStudyDetailTemplate global={global} pageData={pageData} />
}

export default CaseStudyDetailTR

type SSRProps = {
  query: {
    caseStudyId: string
  }
}

export async function getServerSideProps({ query }: SSRProps) {
  const { caseStudyId } = query

  if (!caseStudyId) {
    return {
      notFound: true,
    }
  }

  const pageData = await ResearchAreaService.getCaseStudyPageData(
    'tr',
    caseStudyId
  )

  return {
    props: {
      pageData,
    },
  }
}
